import React, { useEffect } from "react";

const CrispChat = () => {
  useEffect(() => {
    // Create script element
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `window.$crisp=[];window.CRISP_WEBSITE_ID="62f30a33-35ac-4f8b-aae2-a9e7f9fa7930";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();`;
    // Append script to head
    document.head.appendChild(script);

    // Cleanup script when component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default CrispChat;
